import React, { useMemo } from "react";
import classes from "./carousel.shimmer.module.css";

const CarouselShimmer = () => {
  const thumbnails = useMemo(() => {
    return Array.from({ length: 4 })
      .fill(null)
      .map((value, index) => {
        return (
          <div className={classes.thumbnailRoot} key={`thumbnail-${index}`}>
            <div className={classes.thumbnailCard}></div>
          </div>
        );
      });
  }, [classes]);

  return (
    <div className={classes.productcontainer_zoom}>
      <div className={classes.root}>
        <div className={classes.carouselContainer}>
          <section className={classes.imageContainer}>
            <div className={classes.currentImage}>
              <div className={classes.fakeImage}></div>
            </div>
          </section>
        </div>
        <div
          className={`${classes.productslidernew} d-sm-none d-md-none d-lg-block `}
        >
          <div
            className={`${classes.thumbnailList} product-detail-carousel`}
            style={{ overflow: "hidden" }}
          >
            {thumbnails}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarouselShimmer;
